import { RootState } from 'handlers';

export const getProfessionGroup = ({ professionGroup }: RootState) => professionGroup;
